import React, { Component } from 'react';
import './css/ContextMenu.css';
//import FX from './functions/functions';



class ContextMenu extends Component {
  constructor(props) {
    super(props);
    this.today = new Date();
    this.myRef = React.createRef();
    console.log(React.version);
    if(Array.isArray(this.props.location)){
        this.state = {left:this.props.location[0] ,
              top:this.props.location[1]}
    }
    else {
      this.state = {left:0 ,
              top:0}
    }
  }
  onScreen = () => {
    
    if(this.myRef && this.myRef.current !== null ){
        console.log(this.myRef.current);
        console.log(this.myRef.current.getBoundingClientRect());
        console.log((this.myRef.current.getBoundingClientRect().right - window.innerWidth));
        console.log(Math.max(0, (this.myRef.current.getBoundingClientRect().right - window.innerWidth)));
        console.log(Math.max(0, (this.myRef.current.getBoundingClientRect().bottom - window.innerHeight)));
        var k = {
                  left:Math.max(0, (20 + this.myRef.current.getBoundingClientRect().right - window.innerWidth)) ,
                  top:Math.max(0, (20 + this.myRef.current.getBoundingClientRect().bottom - window.innerHeight))
             }
             if( k.left || k.right){
                 this.setState({
                    left:this.state.left - k.left,
                    top:this.state.right - k.right
                 });
             }
       return false;
    }
    return true;
  }
  componentDidMount(){
    window.onwheel = () => { if (this.props.show) { console.log('nope'); return false; } }
    console.log('xxxxx');
    console.log(this.myRef);
    console.log(window.innerWidth);
    //console.log(this.props.location[0] - Math.max(0, (this.myRef.current.getBoundingClientRect().right - window.innerWidth)));
    this.onScreen();
  }
  componentDidUpdate(prevProps, prevState){
    console.log('yyyyy');
      if(Array.isArray(this.props.location) && this.props.location !== prevProps.location){
        console.log({left:this.props.location[0],top:this.props.location[1]});
        this.setState({left:this.props.location[0] ,
              top:this.props.location[1]})
      }
      this.onScreen();
  }
  componentWillUnmount(){
    window.onwheel = undefined;
    console.log('yyyyy');
  }
  
  contextHide = () => {
    console.log('Try Close')
    if(this.props.contextHide && typeof this.props.contextHide === 'function' ){
      this.props.contextHide();
    }
    else if (this.props.parent.contextHide && typeof this.props.parent.contextHide === 'function'){
      this.props.parent.contextHide();
    }
  }
  render(){
    if(this.props.show){
        if(this.props.children){
          var posStyle;
          console.log(this.myRef);
          if(this.props.location && this.myRef && this.myRef.current !== null){
            posStyle = {left:this.props.location[0] - Math.max(0, (this.myRef.current.getBoundingClientRect().right - window.innerWidth)) ,
            top:this.props.location[1]}
          }
          else {
            posStyle = {left:this.props.location[0] ,
            top:this.props.location[1]}
          }
          return (
            <div onClick={this.contextHide} className="contextMenu" id="ContextMenu">
                <div style={{left: this.state.left,top: this.state.top}} ref={this.myRef} onClick={(e)=>{e.stopPropagation();}} className="contextMenuWindow">
                {this.props.children}
                </div>
            </div>
          );
        }
        else {
          var options = this.props.options.map(opt => {
            var fx;
            if(typeof opt.action === 'function'){
              fx = () => {opt.action(); this.contextHide();}
            }
            else {
              fx = () => {this.contextHide(); return false;};
            }
            return <div className="option" onClick={fx}>{opt.title}</div>
          })
          var posStyle;
          console.log(this.myRef);
          if(this.props.location && this.myRef && this.myRef.current !== null){
            posStyle = {left:this.props.location[0] - Math.max(0, (this.myRef.current.getBoundingClientRect().right - window.innerWidth)) ,
            top:this.props.location[1]}
          }
          else {
            posStyle = {left:this.props.location[0] ,
            top:this.props.location[1]}
          }
          return (
            <div onClick={this.contextHide} className="contextMenu" id="ContextMenu">
                <div style={{left: this.state.left,top: this.state.top}}  ref={this.myRef} onClick={(e)=>{e.stopPropagation();}} className="contextMenuWindow">
                    {options}
                </div>
            </div>
          );
        }
    }
    else{
        return null;
    }
  }
}
export default ContextMenu;



// WEBPACK FOOTER //
// ./src/ContextMenu.js